/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateUpgradeStartResponseDto
 */
export interface UpdateUpgradeStartResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStartResponseDto
     */
    csoPortalInstallationUri?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUpgradeStartResponseDto
     */
    $type?: UpdateUpgradeStartResponseDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateUpgradeStartResponseDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCsoPortalDtoUpdateUpgradeStartResponseDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.CsoPortal.Dto.UpdateUpgradeStartResponseDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateUpgradeStartResponseDtoTypeEnum = typeof UpdateUpgradeStartResponseDtoTypeEnum[keyof typeof UpdateUpgradeStartResponseDtoTypeEnum];



/**
 * Check if a given object implements the UpdateUpgradeStartResponseDto interface.
 */
export function instanceOfUpdateUpgradeStartResponseDto(value?: unknown): value is UpdateUpgradeStartResponseDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateUpgradeStartResponseDtoTypeEnum)[0];
}

export function UpdateUpgradeStartResponseDtoFromJSON(json: any): UpdateUpgradeStartResponseDto {
    return UpdateUpgradeStartResponseDtoFromJSONTyped(json, false);
}

export function UpdateUpgradeStartResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUpgradeStartResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'csoPortalInstallationUri': json['csoPortalInstallationUri'] == null ? undefined : json['csoPortalInstallationUri'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateUpgradeStartResponseDtoToJSON(value?: UpdateUpgradeStartResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'csoPortalInstallationUri': value['csoPortalInstallationUri'],
        '$type': value['$type'],
    });
}

